import { cn } from "@/lib/utils";

interface OnboardingProgressProps {
  currentStep: number;
  totalSteps: number;
  stepTitle?: string;
}

/**
 * Renders the onboarding step indicator as "{stepTitle} — {current}/{total}".
 *
 * Presentational component — no state, no side effects.
 */
export const OnboardingProgress = ({
  currentStep,
  totalSteps,
  stepTitle,
}: OnboardingProgressProps) => {
  return (
    <div className="flex flex-col gap-1">
      <p
        aria-label={`Paso ${(currentStep - 1)} de ${totalSteps}`}
        className={cn("text-sm font-medium text-muted-foreground")}
      >
        Paso {currentStep - 1} de {totalSteps}
      </p>
      {stepTitle && (
        <p className="text-xs text-muted-foreground/70">{stepTitle}</p>
      )}
    </div>
  );
};
